<template>
  <div id="viewBrand">
    <div class="box" v-if="data.length!={}">
      <div class="lv2Text t">品牌详情</div>
      <div class="box line">
        <div class="lv1Text t2">{{data.name}}</div>
        <div class="lv3Text">品牌国别：</div>
        <div class="lv2Text">{{data.country}}</div>
        <div class="lv3Text">代表产品：</div>
        <div class="lv2Text">{{data.main_products}}</div>
        <div class="lv3Text">品牌简介：</div>
        <div class="lv2Text" v-html="data.info"></div>
        <div class="lv3Text">加入时间：</div>
        <div class="lv2Text">{{dayjs.unix(data.create_date).format('YYYY-MM-DD')}}</div>
      </div>
      <div class="btns">
        <router-link to="/user/brand/1" style="margin-right:30px">
          <el-button>返回列表</el-button>
        </router-link>
        <el-button type="primary" @click="go(data.website)">品牌官网</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: {}
    };
  },
  created() {
    //
    this.$store.state.user_location = "关注的品牌";
    this.$store.state.leftMenuIndex = 18;
    this.initData();
  },
  methods: {
    go(v) {
      window.location.href = v;
    },
    initData() {
      this.axios
        .get(this.serve + "/collect/brand_detail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss">
#viewBrand {
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 30px;
    .t {
      margin-bottom: 20px;
    }
    .t2 {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .line {
      line-height: 2em;
    }
    .btns {
      margin-top: 20px;
    }
  }
}
</style>